import React, { useRef, useState } from "react";
import MainSVGComponent from "./MainSVGComponent";
import MinimapComponent from "./MinimapComponent";
import { courtStyles as styles } from "./court.tailwind"
import { useSelector } from "react-redux";
import TokenColorDetails from "./TokenColorDetails";
import { DEFAULT_H, DEFAULT_W } from "./court.data";
import { MAX_TOKEN_BUY_NOTE } from "../../../../lib/constants/globalConstant";
const INITIAL_SCALE = 0.65;

const CourtsWrapper = ({ showHoveredTooltip, currentCommentary, showZoneOnMobileScreen, courtOuterSvgId, previewGame, makeSelectable, selectedZones, zonesToBeHighlighted, selectZone, isScorerPage, hideZoneName, isLiveGame, isDeployTokenPage,  teamDetails, purchasedTokens, hideHover, disableTokenHover }) => {
  const svgRef = useRef(null);

  const [viewBox, setViewBox] = useState({
    x: (DEFAULT_W - (DEFAULT_W / INITIAL_SCALE)) / 2, // Perfect Center X
    y: (DEFAULT_H - (DEFAULT_H / INITIAL_SCALE)) / 2, // Perfect Center Y
    w: DEFAULT_W / INITIAL_SCALE,
    h: DEFAULT_H / INITIAL_SCALE,
  });
  const [scale, setScale] = useState(INITIAL_SCALE);

  const { currentSeason } = useSelector((state) => state.seasons)

  // Function to update the viewBox passed from the main SVG component
  const handleViewBoxChange = (newViewBox) => {
    setViewBox(newViewBox);
  };

  return (
    <div className={`${!previewGame && styles.outerContainerForBuyToken}`}>
      {!previewGame && (
        <>
          <div className={`${styles.legendContainer}`}>
            {/* <div className={`${styles.legendImageContainer}`}>
              <img className={`${styles.legendImage}`} src={currentSeason?.homeTeam?.teamImage}></img>
            </div> */}
            <div className={`${styles.legendTextContainer}`}>
              {/* <p className={`${styles.textHeader}`}>{currentSeason?.homeTeam?.teamName}</p>
              <p className={`${styles.subHeader}`}>Home Team</p> */}
               <p className={`${styles.textHeader}`}>{currentSeason?.sportComplexes[0]?.sportsComplexName}</p>
            </div>
          </div>
          
          {!previewGame && <TokenColorDetails />}
          {!previewGame && <span className={styles.noteTextTop}>
            {MAX_TOKEN_BUY_NOTE}
          </span>}
        </>
      )}

      <div className={`${(previewGame && !isScorerPage) ? 'max-h-[300px]' : ''} ${styles.highOrderWrapper}`}>
        <MainSVGComponent
          ref={svgRef}
          viewBox={viewBox}
          setViewBox={setViewBox}
          onViewBoxChange={handleViewBoxChange}
          scale={scale}
          setScale={setScale}
          previewGame={previewGame}
          showHoveredTooltip={showHoveredTooltip}
          makeSelectable={makeSelectable}
          zonesToBeHighlighted={zonesToBeHighlighted}
          selectedZones={selectedZones}
          selectZone={selectZone}
          hideZoneName={hideZoneName}
          isLiveGame={isLiveGame}
          teamDetails={teamDetails}
          purchasedTokens={purchasedTokens}
          isDeployTokenPage={isDeployTokenPage}
          hideHover={hideHover}
          disableTokenHover={disableTokenHover}
          courtOuterSvgId={courtOuterSvgId}
          showZoneOnMobileScreen={showZoneOnMobileScreen}
          currentCommentary={currentCommentary}
        />

        {!previewGame && (
          <>
            <MinimapComponent
              DEFAULT_W={DEFAULT_W}
              DEFAULT_H={DEFAULT_H}
              viewBox={viewBox}
              scale={scale}
              onViewBoxChange={handleViewBoxChange}
              hideZoneName={hideZoneName}
            />
            <span className={styles.noteTextBelow}>
              {MAX_TOKEN_BUY_NOTE}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default CourtsWrapper;
